import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import ArchitecteInterieurLyon from "@/pages/ArchitecteInterieurLyon";

export const Route = createFileRoute("/architecte-interieur-lyon")({
  head: () =>
    routeHead({
      path: '/architecte-interieur-lyon',
      title: "Architecte d'intérieur Lyon & Rhône-Alpes | JIIA Studio",
      description: "JIIA Studio, architecte d'intérieur à l'ouest de Lyon. Aménagement, décoration, images 3D et suivi de travaux pour particuliers et professionnels.",
    }),
  component: ArchitecteInterieurLyon,
});
